/* ============================================================
   FLOMÉ FLOWERS & HOME — Custom JS
   Transparent header · Fade-in · Card hover
   ============================================================ */

(function () {
  'use strict';

  /* ── Transparent → cream header on scroll ───────────────── */
  const initScrollHeader = () => {
    // Dawn's sticky-header already handles the sticky CSS class.
    // This adds a fallback class on <html> for browsers/themes
    // where shopify-section-header-sticky fires inconsistently.
    const THRESHOLD = 80;

    const update = () => {
      if (window.scrollY > THRESHOLD) {
        document.documentElement.classList.add('flome-scrolled');
      } else {
        document.documentElement.classList.remove('flome-scrolled');
      }
    };

    window.addEventListener('scroll', update, { passive: true });
    update(); // run once on load
  };

  /* ── Fade-in on scroll ───────────────────────────────────── */
  const initFadeIn = () => {
    const targets = document.querySelectorAll(
      '.shopify-section:not(:first-child), .card-wrapper, .multicolumn-card'
    );

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('flome-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px -32px 0px' }
    );

    targets.forEach((el) => {
      el.classList.add('flome-fade-in');
      observer.observe(el);
    });
  };

  /* ── Card hover scale ────────────────────────────────────── */
  const initCardHover = () => {
    document.querySelectorAll('.card-wrapper').forEach((card) => {
      card.addEventListener('mouseenter', () => {
        card.style.setProperty('--flome-card-scale', '1.035');
      });
      card.addEventListener('mouseleave', () => {
        card.style.setProperty('--flome-card-scale', '1');
      });
    });
  };

  /* ── Init ────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initScrollHeader();
    initFadeIn();
    initCardHover();
  });
})();
